module.exports = __webpack_public_path__ + "img/lemon.b425de1c.svg";